import React, { createContext, useContext, useState, useCallback } from "react";

// Create Context
const ToastContext = createContext();

// Custom Hook to use the Toast Context
export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    // Add a new toast
    const addToast = useCallback((message, type = "success") => {
        const id = Date.now();
        setToasts((prevToasts) => [...prevToasts, { id, message, type }]);
        // Remove toast after 5 seconds
        setTimeout(() => {
            setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
        }, 5000);
    }, []);

    return (
        <ToastContext.Provider value={{ addToast }}>
            {children}
            {/* Render Toast Container */}
            <div
                style={{
                    position: "fixed",
                    top: "1rem",
                    right: "1rem",
                    zIndex: 1050,
                }}
            >
                {toasts.map((toast) => (
                    <div
                        key={toast.id}
                        className={`toast show bg-${toast.type} text-white`}
                        style={{ minWidth: "200px" }}
                    >
                        <div className="toast-body">
                            {(toast.type === "error" || toast.type === "warning") && <img className="toast-img" src="./triangle-warning.png" alt="toast-img" />}
                            {(toast.type === "success" ) && <img className="toast-img" src="./checked.png" alt="toast-img" />}
                            {(toast.type === "info") && <img className="toast-img" src="./info.png" alt="toast-img" />}
                            {toast.message}</div>
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
};
